import axios from "axios";
import { Agent } from "../interfaces/agent.interface";

class AgentsApi
 {

  getAgents(): Promise<Agent[]> {
    const apiUrl = "/api/v1/users/agents";

    return axios.get(apiUrl)
    .then(response => {
      const agents = response.data.agents.map(agentData => {
        const agent:Agent = {
          id: agentData.id,
          name: agentData.full_name,
          email: agentData.email,
          image: agentData.image,
          phone: agentData.phone,
          whatsapp: agentData.whatsapp_no,
          address: agentData.address,
          city: agentData.city,
          state: agentData.state,
        }
        return agent;
      })
      return Promise.resolve(agents);
    });
  }

}

export default AgentsApi
;